<template>
    <tr class="rate-history-row rate-history-row-qc">
        <slot name="prepend-cells"></slot>
        <td colspan="16">
            QC'd by {{ qcUser.first_name }} {{ qcUser.last_name }} (user id {{ qcUser.id }}) on {{ qcReadableTime }}
        </td>
        <slot name="append-cells"></slot>
    </tr>
</template>

<script>
export default {
    name: 'rate-list-history-qc-row',
    props: {
        qcTime: {
            type: String
        },
        qcUser: {
            type: Object
        },
    },
    computed: {
        qcReadableTime () {
            return moment(this.qcTime).format('MMMM Do YYYY, h:mm:ss a')
        }
    }
}
</script>
